import React from 'react';
import { Link } from 'react-router-dom';

const Expired = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold text-red-600 mb-4">❌ Magic Link Expired</h2>
        <p className="text-gray-700 mb-6">
          This magic login link is no longer valid. It may have expired or already been used.
        </p>
        <Link
          to="/"
          className="inline-block bg-blue-600 text-white px-5 py-2 rounded-xl font-medium hover:bg-blue-700 transition"
        >
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default Expired;